<div class="cf-dlg">
  <div class="cf-dlg-header">
    <div class="cf-dlg-icon" [class.cf-dlg-icon--blue]="!isReintegro"><mat-icon>{{ isReintegro ? 'remove_circle_outline' : 'person_add' }}</mat-icon></div>
    <div class="ef-header-text">
      <h2 class="cf-dlg-title">{{ tittle }}</h2>
      <p class="cf-dlg-subtitle" *ngIf="subtitle">{{ subtitle }}</p>
    </div>
    <button mat-icon-button class="cf-dlg-close" (click)="closeDialog()" [disabled]="saving" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <app-loading-state *ngIf="!ready" message="Cargando movimientos del socio…"></app-loading-state>
  <app-loading-state *ngIf="ready && saving" [message]="savingMessage"></app-loading-state>

  <ng-container *ngIf="ready && !saving && loadError">
    <div class="cf-dlg-body">
      <div class="ef-empty ef-empty--error">
        <mat-icon>error</mat-icon>
        <span>No se pudieron cargar los movimientos del socio.</span>
      </div>
    </div>
    <div class="cf-dlg-footer">
      <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="closeDialog()">Cerrar</button>
      <button mat-flat-button class="cf-dlg-btn-primary" (click)="retry()">
        <mat-icon>refresh</mat-icon> Reintentar
      </button>
    </div>
  </ng-container>

  <ng-container *ngIf="ready && !saving && !loadError">
    <div class="cf-dlg-body ef-body">

      <div class="ef-summary">
        <div class="ef-summary__left">
          <div class="ef-summary__icon"><mat-icon>people</mat-icon></div>
          <div>
            <span class="ef-summary__label">{{ isReintegro ? 'Reintegrado' : 'Ingresado' }} en {{ year }}</span>
            <span class="ef-summary__amount">{{ totalImporte | number:'1.2-2' }} €</span>
            <span class="ef-summary__hint">
              {{ dataSource.length }} {{ dataSource.length === 1 ? 'movimiento' : 'movimientos' }}<ng-container *ngIf="isReintegro"> · Comisiones {{ totalComisiones | number:'1.2-2' }} €</ng-container>
            </span>
          </div>
        </div>
      </div>

      <div class="ef-section">
        <span class="cf-dlg-section__label">
          {{ isEditMode ? 'Editar ' + elementName : 'Nuevo ' + elementName }}
          <button *ngIf="isEditMode" type="button" class="ef-link" (click)="cancelEdit()">Cancelar edición</button>
        </span>

        <div class="cf-dlg-mismatch" *ngIf="saveError">
          <mat-icon>error_outline</mat-icon>
          <span>{{ saveError }}</span>
        </div>

        <div class="ef-grid">
          <div class="cf-field--required" [class.cf-field--invalid]="submitted && missingDate">
            <app-date [control]="control('fecha')" [config]="{ label: 'Fecha', required: true }"></app-date>
            <div class="cf-field__error" *ngIf="submitted && missingDate"><mat-icon>error</mat-icon> Indica la fecha</div>
          </div>

          <div class="cf-field--required" [class.cf-field--invalid]="submitted && missingConcept">
            <app-field [control]="control('concepto')" [config]="{ label: 'Concepto', type: 'text', required: true, maxLength: 100, hint: conceptoLength + '/100' }"></app-field>
            <div class="cf-field__error" *ngIf="submitted && missingConcept"><mat-icon>error</mat-icon> Indica el concepto</div>
          </div>
        </div>

        <div class="ef-grid">
          <div class="cf-field--required" [class.cf-field--invalid]="submitted && missingImporte">
            <app-field [control]="control('importe')" [config]="{ label: 'Importe', type: 'number', required: true, inputmode: 'decimal', step: 0.01, suffix: '€' }"></app-field>
            <div class="cf-field__error" *ngIf="submitted && missingImporte"><mat-icon>error</mat-icon> Indica un importe distinto de cero</div>
          </div>

          <div *ngIf="isReintegro">
            <app-field [control]="control('comisiones')" [config]="{ label: 'Comisiones', type: 'number', inputmode: 'decimal', step: 0.01, suffix: '€' }"></app-field>
          </div>
        </div>

        <div class="ef-grid">
          <div class="cf-field--required" [class.cf-field--invalid]="submitted && missingPartner">
            <app-autocomplete [control]="control('partner')" [config]="{ label: 'Socio', placeholder: 'Seleccionar socio…', options: partners, required: true, autoSelectSingle: true, strict: true }">
            </app-autocomplete>
            <div class="cf-field__error" *ngIf="submitted && missingPartner"><mat-icon>error</mat-icon> Selecciona el socio</div>
          </div>

          <div class="cf-field--required" [class.cf-field--invalid]="submitted && missingActivity">
            <app-autocomplete [control]="control('activity')" [config]="{ label: 'Actividad', placeholder: 'Seleccionar actividad…', options: activities, required: true, autoSelectSingle: true, strict: true }">
            </app-autocomplete>
            <div class="cf-field__error" *ngIf="submitted && missingActivity"><mat-icon>error</mat-icon> Selecciona la actividad</div>
          </div>
        </div>
      </div>

      <div class="ef-section">
        <span class="cf-dlg-section__label">Registrados en {{ year }}</span>

        <app-loading-state *ngIf="loadingList" [compact]="true" message="Actualizando movimientos…"></app-loading-state>

        <ng-container *ngIf="!loadingList">
          <div class="ef-empty" *ngIf="!dataSource.length">
            <mat-icon>inbox</mat-icon>
            <span>Todavía no hay movimientos de este tipo en la caja.</span>
          </div>

          <div class="ef-rows" *ngIf="dataSource.length">
            <div class="ef-row" *ngFor="let row of dataSource; trackBy: trackByUid" [class.ef-row--editing]="editing?.uid === row.uid">
              <div class="ef-row__main">
                <div class="ef-row__concept" [title]="row.concepto">{{ row.concepto || 'Sin concepto' }}</div>
                <div class="ef-row__meta">
                  {{ row.fecha | date:'dd/MM/yyyy' }}{{ row.partnersName ? ' · ' + row.partnersName : '' }}{{ row.activitiesName ? ' · ' + row.activitiesName : '' }}
                </div>
              </div>
              <div class="ef-row__amount">
                <strong>{{ row.importe | number:'1.2-2' }} €</strong>
                <span *ngIf="isReintegro && row.comisiones">Comisiones {{ row.comisiones | number:'1.2-2' }} €</span>
              </div>
              <div class="ef-row__actions">
                <button type="button" mat-icon-button class="ef-row__btn" (click)="edit(row)" title="Editar" aria-label="Editar movimiento">
                  <mat-icon>edit</mat-icon>
                </button>
                <button type="button" mat-icon-button class="ef-row__btn ef-row__btn--danger" (click)="delete(row)" title="Eliminar" aria-label="Eliminar movimiento">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>

    <div class="cf-dlg-footer">
      <button type="button" mat-stroked-button class="cf-dlg-btn-secondary" (click)="closeDialog()">Cerrar</button>
      <button type="button" mat-flat-button class="cf-dlg-btn-primary" (click)="save()" [disabled]="saving">
        <mat-icon>{{ isEditMode ? 'save' : 'add' }}</mat-icon> {{ isEditMode ? 'Guardar cambios' : 'Añadir ' + elementName }}
      </button>
    </div>
  </ng-container>
</div>
